import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetArtisanCommandsController::__invoke
* @see app/Http/Controllers/SAManagement/GetArtisanCommandsController.php
* @route '/api/sa-management/command-runner/commands'
*/
const GetArtisanCommandsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetArtisanCommandsController.url(options),
    method: 'get',
})

GetArtisanCommandsController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/command-runner/commands',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetArtisanCommandsController::__invoke
* @see app/Http/Controllers/SAManagement/GetArtisanCommandsController.php
* @route '/api/sa-management/command-runner/commands'
*/
GetArtisanCommandsController.url = (options?: RouteQueryOptions) => {
    return GetArtisanCommandsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetArtisanCommandsController::__invoke
* @see app/Http/Controllers/SAManagement/GetArtisanCommandsController.php
* @route '/api/sa-management/command-runner/commands'
*/
GetArtisanCommandsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetArtisanCommandsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetArtisanCommandsController::__invoke
* @see app/Http/Controllers/SAManagement/GetArtisanCommandsController.php
* @route '/api/sa-management/command-runner/commands'
*/
GetArtisanCommandsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetArtisanCommandsController.url(options),
    method: 'head',
})

export default GetArtisanCommandsController